import React from 'react';
import { Link } from 'react-router-dom';

import FormTitle from 'components/PageLayout/FormTitle';
import Button from 'components/digifi-wrappers/Button';
import { CuroAppRoute } from 'enums/curo/CuroAppRoute';
import { getSignInProcessState } from 'handlers/curo-handlers/selectors';
import { useAppSelector } from 'hooks/reduxHooks';
import CuroAuthorizedLayout from 'layout/CuroAuthorizedLayout';
import CuroMainLayout from 'layout/CuroMainLayout';
import { NotFoundIcon } from 'static/images';

import styles from './NotFoundPage.module.scss';

const PAGE_TITLE = 'Oops!';
const PAGE_DESCRIPTION = (
  <div className={styles.pageDescription}>
    Some error occurred.
    <br />
    Please try again by returning to Homepage.
  </div>
);

export const NotFoundPageContent = () => {
  return (
    <div className={styles.pageContainer}>
      <div>
        <FormTitle title={PAGE_TITLE} subTitle={PAGE_DESCRIPTION} />
        <Link to={CuroAppRoute.Home}>
          <Button kind="primary">Go to Homepage</Button>
        </Link>
      </div>
      <NotFoundIcon />
    </div>
  );
};

const NotFoundPage = () => {
  const { accountData } = useAppSelector(getSignInProcessState);

  const shouldShowAuthorizedPage = accountData;

  const renderPage = () => {
    if (shouldShowAuthorizedPage) {
      return (
        <CuroAuthorizedLayout>
          <NotFoundPageContent />
        </CuroAuthorizedLayout>
      );
    }

    return (
      <CuroMainLayout>
        <NotFoundPageContent />
      </CuroMainLayout>
    );
  };

  return renderPage();
};

export default NotFoundPage;
